// Country codes with flags for phone input
export const COUNTRY_CODES = [
  // Priority countries
  { code: "+52", country: "México", flag: "🇲🇽", priority: true },
  { code: "+1", country: "Estados Unidos", flag: "🇺🇸", priority: true },
  { code: "+1", country: "Canadá", flag: "🇨🇦", priority: true },
  { code: "+86", country: "China", flag: "🇨🇳", priority: true },
  { code: "+54", country: "Argentina", flag: "🇦🇷", priority: true },
  // Other countries (alphabetically)
  { code: "+93", country: "Afganistán", flag: "🇦🇫" },
  { code: "+355", country: "Albania", flag: "🇦🇱" },
  { code: "+49", country: "Alemania", flag: "🇩🇪" },
  { code: "+376", country: "Andorra", flag: "🇦🇩" },
  { code: "+244", country: "Angola", flag: "🇦🇴" },
  { code: "+966", country: "Arabia Saudita", flag: "🇸🇦" },
  { code: "+213", country: "Argelia", flag: "🇩🇿" },
  { code: "+374", country: "Armenia", flag: "🇦🇲" },
  { code: "+61", country: "Australia", flag: "🇦🇺" },
  { code: "+43", country: "Austria", flag: "🇦🇹" },
  { code: "+994", country: "Azerbaiyán", flag: "🇦🇿" },
  { code: "+973", country: "Baréin", flag: "🇧🇭" },
  { code: "+880", country: "Bangladés", flag: "🇧🇩" },
  { code: "+32", country: "Bélgica", flag: "🇧🇪" },
  { code: "+501", country: "Belice", flag: "🇧🇿" },
  { code: "+229", country: "Benín", flag: "🇧🇯" },
  { code: "+375", country: "Bielorrusia", flag: "🇧🇾" },
  { code: "+591", country: "Bolivia", flag: "🇧🇴" },
  { code: "+387", country: "Bosnia", flag: "🇧🇦" },
  { code: "+267", country: "Botsuana", flag: "🇧🇼" },
  { code: "+55", country: "Brasil", flag: "🇧🇷" },
  { code: "+673", country: "Brunéi", flag: "🇧🇳" },
  { code: "+359", country: "Bulgaria", flag: "🇧🇬" },
  { code: "+226", country: "Burkina Faso", flag: "🇧🇫" },
  { code: "+257", country: "Burundi", flag: "🇧🇮" },
  { code: "+975", country: "Bután", flag: "🇧🇹" },
  { code: "+238", country: "Cabo Verde", flag: "🇨🇻" },
  { code: "+855", country: "Camboya", flag: "🇰🇭" },
  { code: "+237", country: "Camerún", flag: "🇨🇲" },
  { code: "+235", country: "Chad", flag: "🇹🇩" },
  { code: "+56", country: "Chile", flag: "🇨🇱" },
  { code: "+357", country: "Chipre", flag: "🇨🇾" },
  { code: "+57", country: "Colombia", flag: "🇨🇴" },
  { code: "+269", country: "Comoras", flag: "🇰🇲" },
  { code: "+850", country: "Corea del Norte", flag: "🇰🇵" },
  { code: "+82", country: "Corea del Sur", flag: "🇰🇷" },
  { code: "+225", country: "Costa de Marfil", flag: "🇨🇮" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+385", country: "Croacia", flag: "🇭🇷" },
  { code: "+53", country: "Cuba", flag: "🇨🇺" },
  { code: "+45", country: "Dinamarca", flag: "🇩🇰" },
  { code: "+593", country: "Ecuador", flag: "🇪🇨" },
  { code: "+20", country: "Egipto", flag: "🇪🇬" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻" },
  { code: "+971", country: "Emiratos Árabes", flag: "🇦🇪" },
  { code: "+421", country: "Eslovaquia", flag: "🇸🇰" },
  { code: "+386", country: "Eslovenia", flag: "🇸🇮" },
  { code: "+34", country: "España", flag: "🇪🇸" },
  { code: "+372", country: "Estonia", flag: "🇪🇪" },
  { code: "+251", country: "Etiopía", flag: "🇪🇹" },
  { code: "+63", country: "Filipinas", flag: "🇵🇭" },
  { code: "+358", country: "Finlandia", flag: "🇫🇮" },
  { code: "+679", country: "Fiyi", flag: "🇫🇯" },
  { code: "+33", country: "Francia", flag: "🇫🇷" },
  { code: "+241", country: "Gabón", flag: "🇬🇦" },
  { code: "+220", country: "Gambia", flag: "🇬🇲" },
  { code: "+995", country: "Georgia", flag: "🇬🇪" },
  { code: "+233", country: "Ghana", flag: "🇬🇭" },
  { code: "+30", country: "Grecia", flag: "🇬🇷" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹" },
  { code: "+224", country: "Guinea", flag: "🇬🇳" },
  { code: "+240", country: "Guinea Ecuatorial", flag: "🇬🇶" },
  { code: "+592", country: "Guyana", flag: "🇬🇾" },
  { code: "+509", country: "Haití", flag: "🇭🇹" },
  { code: "+504", country: "Honduras", flag: "🇭🇳" },
  { code: "+36", country: "Hungría", flag: "🇭🇺" },
  { code: "+91", country: "India", flag: "🇮🇳" },
  { code: "+62", country: "Indonesia", flag: "🇮🇩" },
  { code: "+964", country: "Irak", flag: "🇮🇶" },
  { code: "+98", country: "Irán", flag: "🇮🇷" },
  { code: "+353", country: "Irlanda", flag: "🇮🇪" },
  { code: "+354", country: "Islandia", flag: "🇮🇸" },
  { code: "+972", country: "Israel", flag: "🇮🇱" },
  { code: "+39", country: "Italia", flag: "🇮🇹" },
  { code: "+1876", country: "Jamaica", flag: "🇯🇲" },
  { code: "+81", country: "Japón", flag: "🇯🇵" },
  { code: "+962", country: "Jordania", flag: "🇯🇴" },
  { code: "+7", country: "Kazajistán", flag: "🇰🇿" },
  { code: "+254", country: "Kenia", flag: "🇰🇪" },
  { code: "+996", country: "Kirguistán", flag: "🇰🇬" },
  { code: "+965", country: "Kuwait", flag: "🇰🇼" },
  { code: "+856", country: "Laos", flag: "🇱🇦" },
  { code: "+266", country: "Lesoto", flag: "🇱🇸" },
  { code: "+371", country: "Letonia", flag: "🇱🇻" },
  { code: "+961", country: "Líbano", flag: "🇱🇧" },
  { code: "+231", country: "Liberia", flag: "🇱🇷" },
  { code: "+218", country: "Libia", flag: "🇱🇾" },
  { code: "+423", country: "Liechtenstein", flag: "🇱🇮" },
  { code: "+370", country: "Lituania", flag: "🇱🇹" },
  { code: "+352", country: "Luxemburgo", flag: "🇱🇺" },
  { code: "+389", country: "Macedonia", flag: "🇲🇰" },
  { code: "+261", country: "Madagascar", flag: "🇲🇬" },
  { code: "+60", country: "Malasia", flag: "🇲🇾" },
  { code: "+265", country: "Malaui", flag: "🇲🇼" },
  { code: "+960", country: "Maldivas", flag: "🇲🇻" },
  { code: "+223", country: "Malí", flag: "🇲🇱" },
  { code: "+356", country: "Malta", flag: "🇲🇹" },
  { code: "+212", country: "Marruecos", flag: "🇲🇦" },
  { code: "+230", country: "Mauricio", flag: "🇲🇺" },
  { code: "+222", country: "Mauritania", flag: "🇲🇷" },
  { code: "+373", country: "Moldavia", flag: "🇲🇩" },
  { code: "+377", country: "Mónaco", flag: "🇲🇨" },
  { code: "+976", country: "Mongolia", flag: "🇲🇳" },
  { code: "+382", country: "Montenegro", flag: "🇲🇪" },
  { code: "+258", country: "Mozambique", flag: "🇲🇿" },
  { code: "+264", country: "Namibia", flag: "🇳🇦" },
  { code: "+977", country: "Nepal", flag: "🇳🇵" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "+227", country: "Níger", flag: "🇳🇪" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+47", country: "Noruega", flag: "🇳🇴" },
  { code: "+64", country: "Nueva Zelanda", flag: "🇳🇿" },
  { code: "+968", country: "Omán", flag: "🇴🇲" },
  { code: "+31", country: "Países Bajos", flag: "🇳🇱" },
  { code: "+92", country: "Pakistán", flag: "🇵🇰" },
  { code: "+507", country: "Panamá", flag: "🇵🇦" },
  { code: "+675", country: "Papúa Nueva Guinea", flag: "🇵🇬" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾" },
  { code: "+51", country: "Perú", flag: "🇵🇪" },
  { code: "+48", country: "Polonia", flag: "🇵🇱" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+974", country: "Qatar", flag: "🇶🇦" },
  { code: "+44", country: "Reino Unido", flag: "🇬🇧" },
  { code: "+236", country: "Rep. Centroafricana", flag: "🇨🇫" },
  { code: "+420", country: "República Checa", flag: "🇨🇿" },
  { code: "+243", country: "Rep. Dem. Congo", flag: "🇨🇩" },
  { code: "+1809", country: "Rep. Dominicana", flag: "🇩🇴" },
  { code: "+250", country: "Ruanda", flag: "🇷🇼" },
  { code: "+40", country: "Rumania", flag: "🇷🇴" },
  { code: "+7", country: "Rusia", flag: "🇷🇺" },
  { code: "+221", country: "Senegal", flag: "🇸🇳" },
  { code: "+381", country: "Serbia", flag: "🇷🇸" },
  { code: "+248", country: "Seychelles", flag: "🇸🇨" },
  { code: "+232", country: "Sierra Leona", flag: "🇸🇱" },
  { code: "+65", country: "Singapur", flag: "🇸🇬" },
  { code: "+963", country: "Siria", flag: "🇸🇾" },
  { code: "+252", country: "Somalia", flag: "🇸🇴" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "+27", country: "Sudáfrica", flag: "🇿🇦" },
  { code: "+249", country: "Sudán", flag: "🇸🇩" },
  { code: "+46", country: "Suecia", flag: "🇸🇪" },
  { code: "+41", country: "Suiza", flag: "🇨🇭" },
  { code: "+597", country: "Surinam", flag: "🇸🇷" },
  { code: "+66", country: "Tailandia", flag: "🇹🇭" },
  { code: "+255", country: "Tanzania", flag: "🇹🇿" },
  { code: "+992", country: "Tayikistán", flag: "🇹🇯" },
  { code: "+228", country: "Togo", flag: "🇹🇬" },
  { code: "+676", country: "Tonga", flag: "🇹🇴" },
  { code: "+1868", country: "Trinidad y Tobago", flag: "🇹🇹" },
  { code: "+216", country: "Túnez", flag: "🇹🇳" },
  { code: "+993", country: "Turkmenistán", flag: "🇹🇲" },
  { code: "+90", country: "Turquía", flag: "🇹🇷" },
  { code: "+380", country: "Ucrania", flag: "🇺🇦" },
  { code: "+256", country: "Uganda", flag: "🇺🇬" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾" },
  { code: "+998", country: "Uzbekistán", flag: "🇺🇿" },
  { code: "+678", country: "Vanuatu", flag: "🇻🇺" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳" },
  { code: "+967", country: "Yemen", flag: "🇾🇪" },
  { code: "+260", country: "Zambia", flag: "🇿🇲" },
  { code: "+263", country: "Zimbabue", flag: "🇿🇼" },
];

// Countries with flags for country selection
export const COUNTRIES_WITH_FLAGS = [
  // Priority countries
  { name: "México", flag: "🇲🇽", priority: true },
  { name: "Estados Unidos", flag: "🇺🇸", priority: true },
  { name: "Canadá", flag: "🇨🇦", priority: true },
  { name: "China", flag: "🇨🇳", priority: true },
  { name: "Argentina", flag: "🇦🇷", priority: true },
  // Other countries (alphabetically)
  { name: "Afganistán", flag: "🇦🇫" },
  { name: "Albania", flag: "🇦🇱" },
  { name: "Alemania", flag: "🇩🇪" },
  { name: "Andorra", flag: "🇦🇩" },
  { name: "Angola", flag: "🇦🇴" },
  { name: "Arabia Saudita", flag: "🇸🇦" },
  { name: "Argelia", flag: "🇩🇿" },
  { name: "Armenia", flag: "🇦🇲" },
  { name: "Australia", flag: "🇦🇺" },
  { name: "Austria", flag: "🇦🇹" },
  { name: "Azerbaiyán", flag: "🇦🇿" },
  { name: "Bahamas", flag: "🇧🇸" },
  { name: "Bangladés", flag: "🇧🇩" },
  { name: "Barbados", flag: "🇧🇧" },
  { name: "Baréin", flag: "🇧🇭" },
  { name: "Bélgica", flag: "🇧🇪" },
  { name: "Belice", flag: "🇧🇿" },
  { name: "Benín", flag: "🇧🇯" },
  { name: "Bielorrusia", flag: "🇧🇾" },
  { name: "Bolivia", flag: "🇧🇴" },
  { name: "Bosnia y Herzegovina", flag: "🇧🇦" },
  { name: "Botsuana", flag: "🇧🇼" },
  { name: "Brasil", flag: "🇧🇷" },
  { name: "Brunéi", flag: "🇧🇳" },
  { name: "Bulgaria", flag: "🇧🇬" },
  { name: "Burkina Faso", flag: "🇧🇫" },
  { name: "Burundi", flag: "🇧🇮" },
  { name: "Bután", flag: "🇧🇹" },
  { name: "Cabo Verde", flag: "🇨🇻" },
  { name: "Camboya", flag: "🇰🇭" },
  { name: "Camerún", flag: "🇨🇲" },
  { name: "Chad", flag: "🇹🇩" },
  { name: "Chile", flag: "🇨🇱" },
  { name: "Chipre", flag: "🇨🇾" },
  { name: "Colombia", flag: "🇨🇴" },
  { name: "Comoras", flag: "🇰🇲" },
  { name: "Corea del Norte", flag: "🇰🇵" },
  { name: "Corea del Sur", flag: "🇰🇷" },
  { name: "Costa de Marfil", flag: "🇨🇮" },
  { name: "Costa Rica", flag: "🇨🇷" },
  { name: "Croacia", flag: "🇭🇷" },
  { name: "Cuba", flag: "🇨🇺" },
  { name: "Dinamarca", flag: "🇩🇰" },
  { name: "Dominica", flag: "🇩🇲" },
  { name: "Ecuador", flag: "🇪🇨" },
  { name: "Egipto", flag: "🇪🇬" },
  { name: "El Salvador", flag: "🇸🇻" },
  { name: "Emiratos Árabes Unidos", flag: "🇦🇪" },
  { name: "Eritrea", flag: "🇪🇷" },
  { name: "Eslovaquia", flag: "🇸🇰" },
  { name: "Eslovenia", flag: "🇸🇮" },
  { name: "España", flag: "🇪🇸" },
  { name: "Estonia", flag: "🇪🇪" },
  { name: "Etiopía", flag: "🇪🇹" },
  { name: "Filipinas", flag: "🇵🇭" },
  { name: "Finlandia", flag: "🇫🇮" },
  { name: "Fiyi", flag: "🇫🇯" },
  { name: "Francia", flag: "🇫🇷" },
  { name: "Gabón", flag: "🇬🇦" },
  { name: "Gambia", flag: "🇬🇲" },
  { name: "Georgia", flag: "🇬🇪" },
  { name: "Ghana", flag: "🇬🇭" },
  { name: "Granada", flag: "🇬🇩" },
  { name: "Grecia", flag: "🇬🇷" },
  { name: "Guatemala", flag: "🇬🇹" },
  { name: "Guinea", flag: "🇬🇳" },
  { name: "Guinea Ecuatorial", flag: "🇬🇶" },
  { name: "Guinea-Bisáu", flag: "🇬🇼" },
  { name: "Guyana", flag: "🇬🇾" },
  { name: "Haití", flag: "🇭🇹" },
  { name: "Honduras", flag: "🇭🇳" },
  { name: "Hungría", flag: "🇭🇺" },
  { name: "India", flag: "🇮🇳" },
  { name: "Indonesia", flag: "🇮🇩" },
  { name: "Irak", flag: "🇮🇶" },
  { name: "Irán", flag: "🇮🇷" },
  { name: "Irlanda", flag: "🇮🇪" },
  { name: "Islandia", flag: "🇮🇸" },
  { name: "Israel", flag: "🇮🇱" },
  { name: "Italia", flag: "🇮🇹" },
  { name: "Jamaica", flag: "🇯🇲" },
  { name: "Japón", flag: "🇯🇵" },
  { name: "Jordania", flag: "🇯🇴" },
  { name: "Kazajistán", flag: "🇰🇿" },
  { name: "Kenia", flag: "🇰🇪" },
  { name: "Kirguistán", flag: "🇰🇬" },
  { name: "Kiribati", flag: "🇰🇮" },
  { name: "Kuwait", flag: "🇰🇼" },
  { name: "Laos", flag: "🇱🇦" },
  { name: "Lesoto", flag: "🇱🇸" },
  { name: "Letonia", flag: "🇱🇻" },
  { name: "Líbano", flag: "🇱🇧" },
  { name: "Liberia", flag: "🇱🇷" },
  { name: "Libia", flag: "🇱🇾" },
  { name: "Liechtenstein", flag: "🇱🇮" },
  { name: "Lituania", flag: "🇱🇹" },
  { name: "Luxemburgo", flag: "🇱🇺" },
  { name: "Macedonia del Norte", flag: "🇲🇰" },
  { name: "Madagascar", flag: "🇲🇬" },
  { name: "Malasia", flag: "🇲🇾" },
  { name: "Malaui", flag: "🇲🇼" },
  { name: "Maldivas", flag: "🇲🇻" },
  { name: "Malí", flag: "🇲🇱" },
  { name: "Malta", flag: "🇲🇹" },
  { name: "Marruecos", flag: "🇲🇦" },
  { name: "Mauricio", flag: "🇲🇺" },
  { name: "Mauritania", flag: "🇲🇷" },
  { name: "Moldavia", flag: "🇲🇩" },
  { name: "Mónaco", flag: "🇲🇨" },
  { name: "Mongolia", flag: "🇲🇳" },
  { name: "Montenegro", flag: "🇲🇪" },
  { name: "Mozambique", flag: "🇲🇿" },
  { name: "Myanmar", flag: "🇲🇲" },
  { name: "Namibia", flag: "🇳🇦" },
  { name: "Nauru", flag: "🇳🇷" },
  { name: "Nepal", flag: "🇳🇵" },
  { name: "Nicaragua", flag: "🇳🇮" },
  { name: "Níger", flag: "🇳🇪" },
  { name: "Nigeria", flag: "🇳🇬" },
  { name: "Noruega", flag: "🇳🇴" },
  { name: "Nueva Zelanda", flag: "🇳🇿" },
  { name: "Omán", flag: "🇴🇲" },
  { name: "Países Bajos", flag: "🇳🇱" },
  { name: "Pakistán", flag: "🇵🇰" },
  { name: "Panamá", flag: "🇵🇦" },
  { name: "Papúa Nueva Guinea", flag: "🇵🇬" },
  { name: "Paraguay", flag: "🇵🇾" },
  { name: "Perú", flag: "🇵🇪" },
  { name: "Polonia", flag: "🇵🇱" },
  { name: "Portugal", flag: "🇵🇹" },
  { name: "Qatar", flag: "🇶🇦" },
  { name: "Reino Unido", flag: "🇬🇧" },
  { name: "República Centroafricana", flag: "🇨🇫" },
  { name: "República Checa", flag: "🇨🇿" },
  { name: "República del Congo", flag: "🇨🇬" },
  { name: "República Democrática del Congo", flag: "🇨🇩" },
  { name: "República Dominicana", flag: "🇩🇴" },
  { name: "Ruanda", flag: "🇷🇼" },
  { name: "Rumania", flag: "🇷🇴" },
  { name: "Rusia", flag: "🇷🇺" },
  { name: "Samoa", flag: "🇼🇸" },
  { name: "San Marino", flag: "🇸🇲" },
  { name: "Senegal", flag: "🇸🇳" },
  { name: "Serbia", flag: "🇷🇸" },
  { name: "Seychelles", flag: "🇸🇨" },
  { name: "Sierra Leona", flag: "🇸🇱" },
  { name: "Singapur", flag: "🇸🇬" },
  { name: "Siria", flag: "🇸🇾" },
  { name: "Somalia", flag: "🇸🇴" },
  { name: "Sri Lanka", flag: "🇱🇰" },
  { name: "Sudáfrica", flag: "🇿🇦" },
  { name: "Sudán", flag: "🇸🇩" },
  { name: "Sudán del Sur", flag: "🇸🇸" },
  { name: "Suecia", flag: "🇸🇪" },
  { name: "Suiza", flag: "🇨🇭" },
  { name: "Surinam", flag: "🇸🇷" },
  { name: "Tailandia", flag: "🇹🇭" },
  { name: "Tanzania", flag: "🇹🇿" },
  { name: "Tayikistán", flag: "🇹🇯" },
  { name: "Timor Oriental", flag: "🇹🇱" },
  { name: "Togo", flag: "🇹🇬" },
  { name: "Tonga", flag: "🇹🇴" },
  { name: "Trinidad y Tobago", flag: "🇹🇹" },
  { name: "Túnez", flag: "🇹🇳" },
  { name: "Turkmenistán", flag: "🇹🇲" },
  { name: "Turquía", flag: "🇹🇷" },
  { name: "Tuvalu", flag: "🇹🇻" },
  { name: "Ucrania", flag: "🇺🇦" },
  { name: "Uganda", flag: "🇺🇬" },
  { name: "Uruguay", flag: "🇺🇾" },
  { name: "Uzbekistán", flag: "🇺🇿" },
  { name: "Vanuatu", flag: "🇻🇺" },
  { name: "Venezuela", flag: "🇻🇪" },
  { name: "Vietnam", flag: "🇻🇳" },
  { name: "Yemen", flag: "🇾🇪" },
  { name: "Yibuti", flag: "🇩🇯" },
  { name: "Zambia", flag: "🇿🇲" },
  { name: "Zimbabue", flag: "🇿🇼" },
];

// Get priority and other countries separated
export const getPriorityCountryCodes = () => COUNTRY_CODES.filter(c => c.priority);
export const getOtherCountryCodes = () => COUNTRY_CODES.filter(c => !c.priority);

export const getPriorityCountries = () => COUNTRIES_WITH_FLAGS.filter(c => c.priority);
export const getOtherCountries = () => COUNTRIES_WITH_FLAGS.filter(c => !c.priority);

// Simple email validation - just needs @
export const isValidEmail = (email) => {
  return email && email.includes("@");
};
